import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PAGE_SIZE } from "./constants";
import {
  generatePermissionTicketsAsync,
  initialAsync,
  revokeAsync,
  updateAsync,
} from "./operations";
import { ActivationState } from "./state";

const initialState: ActivationState = {
  apps: {
    loading: "Loading",
    maxPage: 1,
    pageIndex: 0,
    pageSize: PAGE_SIZE, // const化
  },
  domains: {
    activations: [],
  },
  error: {},
};

export const activationSlice = createSlice({
  name: "activation",
  initialState,
  reducers: {
    // 現在表示しているページのindexを更新する。
    changeNowIndex: (state, action: PayloadAction<{ pegeNumber: number }>) => {
      const { pegeNumber } = action.payload;
      state.apps.pageIndex = pegeNumber;
    },
    changePopupTarget: (state, action: PayloadAction<{ aId: string }>) => {
      const { aId } = action.payload;
      const target = state.domains.activations
        .filter((x) => x.aId === aId)
        .shift();
      if (target) {
        state.apps.popupTarget = {
          aId: target.aId,
          name: target.productName,
          version: target.productVersion,
        };
      }
    },
    clearPopupTarget: (state) => {
      state.apps.popupTarget = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initialAsync.pending, (state) => {
      state.apps = initialState.apps;
      state.domains = initialState.domains;
      state.error = {};
    });
    builder.addCase(initialAsync.fulfilled, (state, action) => {
      const { payload } = action;
      state.apps.loading = "Loaded";
      state.apps.maxPage = payload.maxPage;
      state.apps.pageIndex = payload.pageIndex;
      state.apps.pageSize = payload.pageSize;
      state.domains.activations = payload.activations;
    });
    builder.addCase(initialAsync.rejected, (state, action) => {
      const { payload } = action;
      state.apps.loading = "LoadError";
      state.error = { initialError: payload?.error };
    });
    builder.addCase(updateAsync.pending, (state) => {
      state.apps.loading = "Loading";
      state.error = {};
    });
    builder.addCase(updateAsync.fulfilled, (state, action) => {
      const { payload } = action;
      state.apps.loading = "Loaded";
      state.apps.maxPage = payload.maxPage;
      state.apps.pageIndex = payload.pageIndex;
      state.apps.pageSize = payload.pageSize;
      state.domains.activations = payload.activations;
    });
    builder.addCase(updateAsync.rejected, (state, action) => {
      const { payload } = action;
      state.apps.loading = "LoadError";
      state.error = { updateError: payload?.error };
    });
    builder.addCase(generatePermissionTicketsAsync.pending, (state) => {
      state.apps.loading = "Loading";
      state.error = {};
    });
    builder.addCase(
      generatePermissionTicketsAsync.rejected,
      (state, action) => {
        const { payload } = action;
        state.apps.loading = "LoadError";
        state.error = { generatePermissionTicketError: payload?.error };
      }
    );
    builder.addCase(revokeAsync.pending, (state) => {
      state.apps.excuteState = "Excuting";
      state.error = {};
    });
    builder.addCase(revokeAsync.fulfilled, (state) => {
      state.apps.excuteState = "Excuted";
      state.apps.popupTarget = undefined;
    });
    builder.addCase(revokeAsync.rejected, (state, action) => {
      const { payload } = action;
      state.apps.excuteState = "ExcuteError";
      state.error = { rovokeError: payload?.error };
    });
  },
});
export const { changeNowIndex, changePopupTarget, clearPopupTarget } =
  activationSlice.actions;
export default activationSlice.reducer;
